// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + "admin" + "." + "f8b1d6bc" + ".css"; };